
import { FirearmPoolEntityDecoratorBase } from './firearm-pool.decorator.base';


export class FirearmPoolEntityDecorator extends FirearmPoolEntityDecoratorBase {
  constructor() {
    super();
  }
}



